import React, { useEffect, useState } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';

import Header from '../../components/header/header';
import styles from './layout.module.scss';

const Layout: React.FC<RouteComponentProps> = (props) => {
  const { children, location } = props;
  const [isHeaderVisible, setIsHeaderVisible] = useState(false);

  // const calculateVh = () => {
  //   const vh = window.innerHeight * 0.01;
  //   document.documentElement.style.setProperty('--vh', `${vh}px`);
  // };

  // useEffect(() => {
  //   calculateVh();
  //   if (window) {
  //     window.addEventListener('resize', calculateVh);
  //     window.addEventListener('orientationchange', calculateVh);
  //   }
  //   return () => {
  //     window.removeEventListener('resize', calculateVh);
  //     window.removeEventListener('orientationchange', calculateVh);
  //   };
  // }, []);

  useEffect(() => {
    // not displaying the header for auth page
    if (location.pathname.includes('/meet')) setIsHeaderVisible(true);
    else setIsHeaderVisible(false);
  }, [location]);

  return (
    <div className={styles['root-container']}>
      {isHeaderVisible && <Header />}
      <div className={styles['main-container']}>{children}</div>
    </div>
  );
};

export default withRouter(Layout);
